export default {
  mounted() {
    for (const [key, value] of Object.entries(this.$route.query)) {
      if (key.toLowerCase().includes("utm")) {
        this.$store.commit("data/setSingleUtmParam", [key, value]);
      }
    }
  },
};
